// extracted by mini-css-extract-plugin
module.exports = {"list-width":"250px","list-item":"list-item__list-item___3PJlk"};